import data from "./../../data.json";
import { ensureSlowedVideoFx } from "../constants";

export const popupComponentDefaultProps = {
  slowControl: 1,
  reverbAmount: 1,
  lowPassCutoff: 1500,
  highPassCutoff: 500,
  bitcrusherMode: false,
  bitcrusherAmount: 0.45,
  bassBoostMode: false,
  bassBoostAmount: 0.5,
  phaserMode: false,
  phaserAmount: 0.5,
  echoMode: false,
  echoAmount: 0.5,
  lofiHissVolume: 1,
  rainyMode: false,
  rainVolume: 0.6,
  coffeeShopMode: false,
  coffeeShopVolume: 0.6,
  vinylCrackleMode: false,
  vinylCrackleVolume: 0.55,
  preservePitchMode: false,
  videoFx: null,
  videoFxs: ensureSlowedVideoFx(data.videoFxs),
  isSlowedEnabled: false,
  contentApplying: false,
  musicProOnly: false,
  isHeaderVisible: true,
  isPro: false,
  isProFeaturesLocked: false,
  trialMode: false,
  shareMediaOptIn: false,
  testMode: false,
  paymentHookId: null,
  hookBusy: false,
  hookError: null,
  remainingTrialDays: 0,
  debugMode: false,
  lowPassMode: false,
  highPassMode: false,
  lofiTapeMode: false,
  darkMode: false,
  isFeedbackEnabled: false,
  isRateAppEnabled: false,
  isSlowedAIEnabled: true,
  trackName: null,
  url: null,
  sharingStatus: null,
  onSlowedToggle: () => {},
  onSlowControlChange: () => {},
  onVideoFxChange: () => {},
  onLowPassModeChange: () => {},
  onLofiTapeModeChange: () => {},
  onDarkModeChange: () => {},
  onReverbAmountChange: () => {},
  onLowPassCutoffChange: () => {},
  onHighPassModeChange: () => {},
  onHighPassCutoffChange: () => {},
  onBitcrusherModeChange: () => {},
  onBitcrusherAmountChange: () => {},
  onBassBoostModeChange: () => {},
  onBassBoostAmountChange: () => {},
  onPhaserModeChange: () => {},
  onPhaserAmountChange: () => {},
  onEchoModeChange: () => {},
  onEchoAmountChange: () => {},
  onLofiHissVolumeChange: () => {},
  onRainyModeChange: () => {},
  onRainVolumeChange: () => {},
  onCoffeeShopModeChange: () => {},
  onCoffeeShopVolumeChange: () => {},
  onVinylCrackleModeChange: () => {},
  onVinylCrackleVolumeChange: () => {},
  onPreservePitchModeChange: () => {},
  onAIShuffle: () => {},
  onSlowedAiOpen: () => {},
  onSlowedAiLockedClick: () => {},
  onCopyShareUrl: () => {},
  onCustomizeShortcut: () => {},
  onUpgradeClick: () => {},
  onFeedbackClick: () => {},
  onChangelogClick: () => {},
  onHelpClick: () => {},
  onRateAppClick: () => {},
  onResetProClick: () => {},
  onEndTrialModeClick: () => {},
  onShareMediaOptInChange: () => {},
  onTestModeChange: () => {},
  onRefreshPaymentHookClick: () => {},
  onStartTrialModeClick: () => {},
  billingLoading: false,
  onManageSubscriptionClick: () => {},
  hideManagePlan: false,
};
